import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import { postApi ,baseURL} from '../components/Utility'
import {
  action,  
  makeObservable,
  observable,
 
} from 'mobx';
class SOSLogReportStore {
  soslogRport=[]
  total=0
  loading=false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      soslogRport: observable,
      total:observable,
      loading:observable,
      loadData:action,
     
    });
     this.rootStore = rootStore;
    
  }

  async loadData({offset,limit,companyId,fromDate,toDate,pageNo}) {
    this.loading=true;
    var postData = {"companyId":companyId,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":pageNo}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=traxi_booking&a=sosLogReport", "postData="+base64Input);
    
    this.soslogRport =response?.data?.data?.soslogreport
  
     this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;
  }

  async exportExcel(getData) {
    console.log("getData", getData);
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=traxi_booking&a=exportSosLogexcel&cid=" +
      getData.companyId +      
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  async exportpdf(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=traxi_booking&a=exportSosLogPdf&cid=" +
      getData.companyId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  

}

export default SOSLogReportStore;
